/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { CommerceSpecOperator } from './commerceSpecOperator';


export interface ActivateVLRSpecOperator { 
    service_type: ServiceTypeEnum;
    components: Array<CommerceSpecOperator>;
}
export namespace ActivateVLRSpecOperator {
}


